import { ProjectSuggestions } from '@platform/client';
import { Alert, Modal } from '@platform/components';

export const GenerateNewSuggestionsModal = ({
  organizationId,
  generateNewSuggestions,
  isOpen,
  onClose,
}: {
  organizationId: number;
  generateNewSuggestions: ReturnType<typeof ProjectSuggestions.useGenerateOrgProjectSuggestions>;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      title='Confirm'
      variant='dialog'
      headerDivision='divider'
      onClose={onClose}
      isOpen={isOpen}
      primaryCTA={{
        text: 'Yes, generate new suggestions',
        callback: () => {
          onClose();
          generateNewSuggestions.mutate({ organizationId });
        },
      }}
      secondaryCTA={{
        text: 'No, cancel',
        callback: onClose,
      }}
      ignoreExtraPadding
    >
      <Alert variant='warning'>
        Generating new suggestions will replace the existing suggestions for this organization. Are
        you sure you want to continue?
      </Alert>
    </Modal>
  );
};
